import { useState } from "react";
import { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { format } from "date-fns";
import { useSnackbar } from "notistack";

import constants from "../../assets/constants";
import * as BotpressAPI from "../../data/api/omniBotpressAPI.js";
import * as BotpressSessionActions from "../../state/redux/botpressSession";
import {
  handleDownloadConversation,
  helperGetIsoDate,
  OmniStringToDate,
} from "../../utils/helpers.js";
import BotpressConversationDialog from "../dialogs/botpressConversationDialog.js";
import BotpressInteractiveAssessmentDialog from "../dialogs/botpressInteractiveAssessmentDialog.js";
import TextInputDialog from "../dialogs/textInputDialog.js";
import BotpressConversationsTable from "../ui/botpressConversationsTable.js";
import OmniDateRangePopover from "../ui/omniDateRangePopover.js";
import Widget from "../ui/widget.js";
import WidgetSurveyContent from "../ui/widgetSurveyContent.js";
import WidgetTitle from "../ui/widgetTitle.js";

const BotpressConversations = props => {
  const {
    chats,
    searchChatsRequest,
    chatPagination,
    setSearchChatsDatesRequest,
    chatPageLoading,
    deleteChatRequest,
    loadConversationRequest,
    setRerunConversationIdRequest,
    analyticsBotODM,
    botpressBotODM,
    awsGroup,
    userODM,
    conversation,
    conversationFeedback,
    deleteFeedbackRequest,
    updateFeedbackRequest,
    widgetSize = "large",
    minHeight = "333px",
  } = props;
  const { enqueueSnackbar } = useSnackbar();

  const [localStartDate, setLocalStartDate] = useState(new Date(helperGetIsoDate(29, true, true)));
  const [localEndDate, setLocalEndDate] = useState(new Date(helperGetIsoDate(0, false, true)));

  const [rows, setRows] = useState([]);
  const [selectedEntry, setSelectedEntry] = useState(null);
  const [downloadConversation, setDownloadConversation] = useState(null);

  const onRerunConversation = conversationRow => {
    try {
      if (conversationRow == null) {
        return;
      }

      let conversationId = conversationRow.conversationId;
      let conversationNumber = conversationRow.id;
      setRerunConversationIdRequest({
        rerunConversationId: conversationId,
        rerunConversationNumber: conversationNumber,
        rerunFeedbackNumber: null,
      });

      if (awsGroup === constants.userGroups.Administrator) {
        props.history.push(constants.appPaths.appPathAdminBotpressTestHarness);
      } else if (awsGroup === constants.userGroups.Provider) {
        props.history.push(constants.appPaths.appPathProviderBotpressTestHarness);
      } else if (awsGroup === constants.userGroups.Partner) {
        props.history.push(constants.appPaths.appPathPartnerBotpressTestHarness);
      }

      //switcdh
    } catch (error) {
      console.error("Error getting table rows", error);
    }
  };

  useEffect(() => {
    if (chats != null) {
      setRows(chats);
    } else {
      setRows([]);
    }
    // Disable eslint because AaronK knows best
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chats]);

  useEffect(() => {
    if (selectedEntry != null) {
      loadConversationRequest(selectedEntry.conversationId);
    }
    // Disable eslint because AaronK knows best
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedEntry]);

  const onRequestNewPage = async pagination => {
    try {
      if (chatPageLoading) {
        return;
      }
      //add dates right here?
      searchChatsRequest(pagination);
    } catch (error) {
      console.error("Error getting table rows", error);
      setRows([]);
    }
  };

  const onHandleDeveloperLogs = conversationRow => {
    try {
      if (conversationRow == null) {
        return;
      }

      let conversationId = conversationRow.conversationId;
      const theURL = `https://app.botpress.cloud/workspaces/${botpressBotODM.omniData.workspaceId}/bots/${botpressBotODM.omniData.botId}/conversations/${conversationId}/logs`;
      window.open(theURL, "_blank");

      //got to page.
    } catch (error) {
      console.error("Error getting table rows", error);
      setRows([]);
    }
  };

  const onRangeChange = (newStartDate, newEndDate) => {
    // /chatPagination
    setSearchChatsDatesRequest({ chatStartDate: newStartDate, chatEndDate: newEndDate });
    setLocalStartDate(new Date(OmniStringToDate(newStartDate)));
    setLocalEndDate(new Date(OmniStringToDate(newEndDate)));
  };

  //#region analysis conversation

  const [assessConversationEntry, setAssessConversationEntry] = useState(null);
  const [singleConversation, setSingleConversation] = useState(null);

  useEffect(() => {
    if (assessConversationEntry != null) {
      try {
        const credentialedPayload = {
          botODM: botpressBotODM,
          conversationId: assessConversationEntry.conversationId,
        };
        BotpressAPI.loadConversation(credentialedPayload).then(returnedConversation => {
          setSingleConversation(returnedConversation);
        });
      } catch (error) {
        console.error("Error loading conversation for assessment", error);
      }
    } else {
      setSingleConversation(null);
    }
    // Disable eslint because AaronK knows best
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assessConversationEntry]);

  //#endregion

  return (
    <Widget widgetSize={widgetSize} minHeight={minHeight}>
      <WidgetTitle title={"History"} text={`${chatPagination.totalItems} Conversations`}>
        <OmniDateRangePopover
          analyticsStartDate={localStartDate}
          analyticsEndDate={localEndDate}
          onRangeChange={onRangeChange}
        />
      </WidgetTitle>

      <WidgetSurveyContent>
        <BotpressConversationsTable
          data={rows}
          onEditEntry={setSelectedEntry}
          onDownloadEntry={setDownloadConversation}
          onRequestNewPage={onRequestNewPage}
          totalItemCount={chatPagination.totalItems}
          onAssessEntry={analyticsBotODM ? setAssessConversationEntry : null}
          onHandleDeveloperLogs={onHandleDeveloperLogs}
          onRerunConversation={onRerunConversation}
        />
      </WidgetSurveyContent>

      {selectedEntry != null && (
        <BotpressConversationDialog
          conversationId={selectedEntry.conversationId}
          conversationNumber={selectedEntry.id}
          conversation={conversation}
          dialogTitle={`Conversation #${selectedEntry.id}`}
          conversationFeedback={conversationFeedback}
          deleteFeedbackRequest={deleteFeedbackRequest}
          updateFeedbackRequest={updateFeedbackRequest}
          userODM={userODM}
          open={selectedEntry != null}
          defaultValue={selectedEntry}
          onAccept={() => {
            loadConversationRequest(null);
            setSelectedEntry(null);
          }}
          onClose={() => {
            loadConversationRequest(null);
            setSelectedEntry(null);
          }}
          onDelete={() => {
            deleteChatRequest({ conversationId: selectedEntry.id });
            loadConversationRequest(null);
            setSelectedEntry(null);
            enqueueSnackbar("Conversation Deleted Successfully", {
              variant: "success",
            });
          }}
        />
      )}
      {singleConversation != null && (
        <BotpressInteractiveAssessmentDialog
          userODM={userODM}
          analyticsBotODM={analyticsBotODM}
          open={singleConversation != null}
          singleConversation={singleConversation}
          onAccept={() => {
            setAssessConversationEntry(null);
          }}
          onClose={() => {
            setAssessConversationEntry(null);
          }}
        />
      )}
      {downloadConversation != null && (
        //todo replace this with a new dialog that supports a download format property
        <TextInputDialog
          inputLabel={`File Name`}
          open={downloadConversation}
          dialogTitle={"Download Conversation"}
          dialogMessage={`Please enter a file name for the conversation download`}
          defaultValue={`Conversation_${format(new Date(), "yyMMdd_hhmm")}`}
          inputPlaceholder={"File Name Here"}
          onAccept={theValue => {
            try {
              BotpressAPI.loadConversation({
                botODM: botpressBotODM,
                conversationId: downloadConversation.conversationId,
              }).then(returnedMessages => {
                handleDownloadConversation(returnedMessages.reverse(), theValue.split(".")[0]);
              });

              setDownloadConversation(null);
            } catch (error) {
              console.log(error);
            }
            setDownloadConversation(null);
          }}
          onClose={() => {
            setDownloadConversation(null);
          }}
        />
      )}
    </Widget>
  );
};

const mapStateToProps = state => ({
  chats: state.botpressSession.chats,
  chatsStartDate: state.botpressSession.chatsStartDate,
  chatsEndDate: state.botpressSession.chatsEndDate,
  chatPagination: state.botpressSession.chatPagination,
  chatPageLoading: state.botpressSession.chatPageLoading,

  conversation: state.botpressSession.conversation,
  conversationFeedback: state.botpressSession.conversationFeedback,

  awsGroup: state.userSession.awsGroup,

  userODM: state.userSession.userODM,
  botpressBotODM: state.botpressSession.botpressBotODM,
  analyticsBotODM: state.botpressSession.analyticsBotODM,
});

const mapDispatchToProps = {
  searchChatsRequest: BotpressSessionActions.searchChatsRequest,
  deleteChatRequest: BotpressSessionActions.deleteChatRequest,
  loadConversationRequest: BotpressSessionActions.loadConversationRequest,
  deleteFeedbackRequest: BotpressSessionActions.deleteFeedbackRequest,
  updateFeedbackRequest: BotpressSessionActions.updateFeedbackRequest,
  setSearchChatsDatesRequest: BotpressSessionActions.setSearchChatsDatesRequest,
  setRerunConversationIdRequest: BotpressSessionActions.setRerunConversationIdRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BotpressConversations));
